import styled from 'styled-components';
import { devices, renderStyledElementStyles } from '../../../../../../helpers';
import { VideoModulePositions } from '../../../../types';

export const TextWrapper = styled.div`
  margin-top: 20px;
  @media screen and (min-width: ${devices.breakpoints.tablet}) {
    margin-top: 0;
    padding-left: 15px;
  }

  h2 {
    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.dStyles[VideoModulePositions.LEFT].elements.heading,
      )}
  }

  p {
    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.dStyles[VideoModulePositions.LEFT].elements.paragraph,
      )}
  }
`;
